import React, { useEffect, useState } from 'react'

import { Button, Icon, Modal, notification, Upload } from 'antd'
import { useFormikContext } from 'formik'

import {
  useGetAttachmentsByFormQuery,
  useRemoveAttachmentMutation,
  useUploadAttachmentMutation
} from '../../services/attachements'
import { getMessage } from '../../../../../../util/IntlMessages'
import { useActionType } from '../../hooks/useActionType'

import './styles.less'

const FILE_TYPE = 'application/pdf'

export function ActionPdfUpload() {
  const [newUploadFile, setNewUploadFile] = useState(null)
  const [showModal, setShowModal] = useState(null)
  const [localCurrentUploadedFile, setLocalCurrentUploadedFile] = useState(null)

  const { isNewActionType } = useActionType()

  const {
    values: { actionAttachmentId },
    setFieldValue,
    submitForm
  } = useFormikContext()

  const { data: currentUploadedFile } = useGetAttachmentsByFormQuery(
    { attachmentId: actionAttachmentId },
    {
      skip: !actionAttachmentId
    }
  )

  useEffect(() => {
    setLocalCurrentUploadedFile(currentUploadedFile)
  }, [currentUploadedFile])

  const [uploadAttachment, { isLoading: isLoadingUploadAttachment }] = useUploadAttachmentMutation()
  const [removeAttachment, { isLoading: isLoadingRemoveAttachment }] = useRemoveAttachmentMutation()

  async function handleUploadAttachment(file) {
    const payload = new FormData()
    payload.append('file', file)

    const { data } = await uploadAttachment({ payload })
    if (!data.id) {
      return notification.error({
        description: getMessage('importFail'),
        message: 'Erro'
      })
    }

    setFieldValue('actionAttachmentId', data.id)
    await submitForm()

    setShowModal(null)
    setNewUploadFile(null)

    notification.success({
      description: getMessage('successSavingChanges'),
      message: getMessage('sweetAlerts.success')
    })
  }

  async function handleRemoveAttachment() {
    const attachmentId = localCurrentUploadedFile.id

    setFieldValue('actionAttachmentId', null)

    await submitForm()
    await removeAttachment({ attachmentId })

    setShowModal(null)
    setLocalCurrentUploadedFile(null)

    notification.success({
      description: getMessage('successSavingChanges'),
      message: getMessage('sweetAlerts.success')
    })
  }

  function beforeUpload(file) {
    if (file.type !== FILE_TYPE) {
      return notification.error({
        description: getMessage('importFail'),
        message: 'Erro'
      })
    }

    setNewUploadFile(file)
  }

  return (
    <div className="actionPdfUpload">
      <Upload
        beforeUpload={beforeUpload}
        accept={FILE_TYPE}
        fileList={newUploadFile ? [newUploadFile] : []}
        onRemove={() => setNewUploadFile(null)}
        customRequest={() => ({})}
      >
        <Button type="primary">{`${getMessage('actionTypes.edit.annexVisitGuide')} (.pdf)`}</Button>
      </Upload>

      <Button type="ghost" disabled={!newUploadFile} onClick={() => setShowModal('upload')}>
        <Icon type="upload" theme="outlined" className="default-back-icon" />
      </Button>

      {localCurrentUploadedFile && !newUploadFile && (
        <div className="actionPdfUpload__lastUploadFile">
          <Icon type="paper-clip" theme="outlined" className="actionPdfUpload__clipIcon clipIcon" />
          <a href={localCurrentUploadedFile?.fileUri} target="_blank" rel="noopener noreferrer">
            <span className="actionPdfUpload__lastUploadFileCaption">{localCurrentUploadedFile?.caption}</span>
          </a>
          <Icon
            type="delete"
            theme="outlined"
            className="actionPdfUpload__trashIcon trashIcon"
            onClick={() => setShowModal('delete')}
          />
        </div>
      )}

      <Modal
        centered={true}
        visible={showModal === 'upload'}
        onOk={async () => await handleUploadAttachment(newUploadFile)}
        confirmLoading={isLoadingUploadAttachment}
        onCancel={() => setShowModal(null)}
      >
        {newUploadFile && (
          <>
            <p>
              Deseja anexar <strong>{newUploadFile.name}</strong> como o Guia de Visita?
            </p>
            <p>
              Essa ação irá {isNewActionType ? 'salvar' : 'atualizar'} todas as alterações feitas no tipo de visita
              atual.
            </p>
          </>
        )}
      </Modal>

      <Modal
        centered={true}
        visible={showModal === 'delete'}
        onOk={handleRemoveAttachment}
        confirmLoading={isLoadingRemoveAttachment}
        onCancel={() => setShowModal(null)}
      >
        {localCurrentUploadedFile && (
          <span>
            Deseja remover <strong>{localCurrentUploadedFile.caption}</strong> como o Guia de Visita?
          </span>
        )}
      </Modal>
    </div>
  )
}
